<div class="n-login-page">
  <div class="n-login-container">
    <!-- Logo -->
    <div class="n-login-logo n-logo-clickable" (click)="navegarHome()" role="link" tabindex="0" (keydown.enter)="navegarHome()">
      <img src="assets/icons/nomoh_logo.svg" alt="Nomoh Logo" />
    </div>

    <!-- Título -->
    <div class="n-login-header">
      <h1 class="n-login-title">{{ 'PAGINA_LOGIN.TITULO' | translate }}</h1>
      <p class="n-login-subtitle">{{ appConfig.title }}</p>
    </div>

    <!-- Formulário -->
    <form [formGroup]="form" class="n-login-form" (ngSubmit)="onSubmit()">
      <!-- Toggle Email/Telefone -->
      <div class="n-login-toggle">
        <button
          type="button"
          class="n-toggle-btn"
          [class.active]="valueLogin"
          (click)="alterarOpcaoLogin(true)"
        >
          {{ 'GLOBAL.TELEFONE' | translate }}
        </button>
        <button
          type="button"
          class="n-toggle-btn"
          [class.active]="!valueLogin"
          (click)="alterarOpcaoLogin(false)"
        >
          {{ 'GLOBAL.EMAIL' | translate }}
        </button>
      </div>

      <!-- Campo Email/Telefone -->
      <div class="n-field-wrapper">
        @if(valueLogin) {
        <lib-form-field
          label="{{ 'GLOBAL.TELEFONE' | translate }}"
          controlName="telefone"
          [required]="true"
        >
          <lib-phone-input
            [value]="form.get('telefone')?.value ?? ''"
            (valueChange)="onTelefoneChange($event)"
          />
        </lib-form-field>
        } @else {
        <lib-form-field
          label="{{ 'GLOBAL.EMAIL' | translate }}"
          controlName="email"
          [required]="true"
        >
          <input
            pInputText
            id="email"
            autocomplete="username"
            formControlName="email"
            [ngClass]="validarClasseErro('email')"
          />
        </lib-form-field>
        }
      </div>

      <!-- Campo Senha -->
      <div class="n-field-wrapper">
        <lib-form-field
          label="{{ 'GLOBAL.SENHA' | translate }}"
          controlName="senha"
          [required]="true"
        >
          <p-password
            id="senha"
            formControlName="senha"
            [feedback]="false"
            [toggleMask]="true"
            autocomplete="current-password"
          ></p-password>
        </lib-form-field>
        <!-- Link Esqueceu Senha -->
        <div class="n-forgot-password">
          <button type="button" class="n-link-text" (click)="recuperarSenha()">
            {{ 'PAGINA_LOGIN.RECUPERAR_SENHA' | translate }}
          </button>
        </div>
      </div>

      <!-- Botão Entrar -->
      <div class="n-form-actions">
        <p-button
          type="submit"
          styleClass="n-btn-primary n-btn-login"
          [loading]="$loadingLogin()"
          [disabled]="!form.valid || $loadingLogin()"
        >
          {{ 'GLOBAL.ENTRAR' | translate }}
        </p-button>
      </div>
    </form>

    <div class="n-oauth-divider">
      <span>{{ 'PAGINA_LOGIN.OU_CONTINUE_COM' | translate }}</span>
    </div>
    <div class="n-oauth-buttons">
      <p-button
        type="button"
        label="Google"
        styleClass="n-btn-oauth n-btn-oauth-google"
        [outlined]="true"
        (onClick)="loginComGoogle()"
        [disabled]="$loadingLogin()"
      >
        <ng-template pTemplate="icon">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
        </ng-template>
      </p-button>
      <p-button
        type="button"
        label="Microsoft"
        styleClass="n-btn-oauth n-btn-oauth-microsoft"
        [outlined]="true"
        (onClick)="loginComMicrosoft()"
        [disabled]="$loadingLogin()"
      >
        <ng-template pTemplate="icon">
          <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden="true">
            <path fill="#f25022" d="M0 0h11v11H0z"/>
            <path fill="#00a4ef" d="M12 0h11v11H12z"/>
            <path fill="#7fba00" d="M0 12h11v11H0z"/>
            <path fill="#ffb900" d="M12 12h11v11H12z"/>
          </svg>
        </ng-template>
      </p-button>
    </div>

    <!-- Link Cadastro -->
    <div class="n-register-link">
      <span>{{ 'PAGINA_LOGIN.CADASTRO.DESCRICAO' | translate }}</span>
      <button type="button" class="n-link-bold" (click)="cadastrar()">
        {{ 'PAGINA_LOGIN.CADASTRO.BOTAO' | translate }}
      </button>
    </div>
  </div>
</div>
